import React from 'react';
import { Link } from 'react-router-dom';
import '../style/home.css';

const Home = () => {
  return (
    <div className='container'>
      <h1 className='heading'>Connect to support AI</h1>
      <Link to="/aisession">
        <button>Connect</button>
      </Link>
    </div>
  );
};

export default Home;